// extracted by mini-css-extract-plugin
export default {"attachmentsList":"AttachmentsList_attachmentsList__8j42T","attachmentRow":"AttachmentsList_attachmentRow__YmLtp"};